import Vue from 'vue'
import moment from 'moment'
import Home from './components/Home'
import Login from './components/Login'
import Configuration from './components/Configuration'
import App from './components/App'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import Championship from './components/Championship'
import progress from 'vue-progressbar'
import Game from './components/Game'
import Players from './components/Players'
import ChampionshipsList from './components/ChampionshipsList'
import ResultList from './components/ResultList'
import Fixtures from './components/Fixtures'
import Sortable from 'vue-sortable'
import Team from './components/configuration/Team'
import Dates from './components/configuration/Dates'
import Categories from './components/configuration/Categories'
import AddCourses from './components/configuration/AddCourses'
import ConfigPlayers from './components/configuration/Players'
import AwardsHome from './components/configuration/AwardsHome'

Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(progress)
Vue.use(Sortable)

Vue.filter('moment', (value) => {
  moment.locale('es')
  return moment(value).format('L')
})

Vue.filter('diff', (value) => {
  if (value > 0) {
    return '+' + value
  }
  return value
})

export var router = new VueRouter()

// Set up routing and match routes to components
router.map({
  '/home': {
    component: Home,
    subRoutes: {
      '/championships': {
        component: ChampionshipsList
      }
    }
  },
  '/championship': {
    component: Championship,
    subRoutes: {
      '/game': {
        component: Game
      },
      '/players': {
        component: Players
      },
      '/results': {
        component: ResultList
      },
      '/fixtures': {
        component: Fixtures
      }
    }
  },
  '/configuration': {
    component: Configuration,
    subRoutes: {
      '/teams': {
        component: Team
      },
      '/dates': {
        component: Dates
      },
      '/categories': {
        component: Categories
      },
      '/courses': {
        component: AddCourses
      },
      '/awards': {
        component: AwardsHome
      },
      '/players': {
        component: ConfigPlayers
      }
    }
  },
  '/login': {
    component: Login
  }
})

// Redirect to the home route if any routes are unmatched
router.redirect({
  '*': '/home'
})

// Start the app on the #app div
router.start(App, '#app')



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/